// The rows of the event videos page's info dialog: every field of the video
// document, nested objects flattened to dotted keys, sorted by key.

// Left out on purpose. The download URL is the Storage path; the sender is
// shown once, as a single identity resolved by `getVideoOwner`, so neither
// the uid nor the typed name appears as a raw field.
const HIDDEN = new Set(['id', 'videoUrl', 'url', 'storagePath', 'uid', 'userName'])

const isTimestamp = (v) => v && typeof v === 'object' && typeof v.seconds === 'number' && typeof v.nanoseconds === 'number'

function display(value) {
  if (value === null || value === undefined) return '—'
  if (isTimestamp(value)) return new Date(value.seconds * 1000).toLocaleString()
  if (Array.isArray(value)) return value.length ? JSON.stringify(value) : '[]'
  return String(value)
}

/**
 * @param {Object} video A `videos` document with its `id`.
 * @returns {Array<{key: string, value: string}>}
 */
export function videoInfoRows(video) {
  const rows = []
  const walk = (obj, prefix) => {
    for (const [k, v] of Object.entries(obj)) {
      const key = prefix ? `${prefix}.${k}` : k
      if (!prefix && HIDDEN.has(k)) continue
      if (v && typeof v === 'object' && !Array.isArray(v) && !isTimestamp(v)) walk(v, key)
      else rows.push({ key, value: display(v) })
    }
  }
  walk(video || {}, '')
  return rows.sort((a, b) => a.key.localeCompare(b.key))
}
